module.exports = __webpack_public_path__ + "static/3p-3-7e3ac0171ee25bf3c8b68ec04221abdb.jpg";